import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useFormattingContext } from '../../../../FormattingProvider/FormattingContext'
import { getContrast } from '../../../../../../utils/colorUtility'

export default function BlockItemLabel ({ labelSize, label, value, formatString, location, backgroundColor = '#eee', textColor: _textColor }) {
  const { formatter } = useFormattingContext()

  const simplifiedColor = useMemo(() => {
    if (!backgroundColor) return '#eee'
    if (backgroundColor.indexOf('gradient') >= 0) {
      const colorMatches = backgroundColor.match(/(rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|#[0-9a-fA-F]{3,6})/g) || []

      for (const color of colorMatches) {
        if (color !== 'rgb(255, 255, 255)' && color.toLowerCase() !== '#ffffff' && color.toLowerCase() !== '#fff') {
          return color
        }
      }
    }
    return backgroundColor
  }, [backgroundColor])

  const textColor = useMemo(() => {
    if (_textColor) return _textColor
    const { lightRatio, darkRatio } = getContrast(simplifiedColor, '#fff')

    if (darkRatio > lightRatio) {
      return '#000'
    }
    return '#fff'
  }, [_textColor, simplifiedColor])

  const fontSizes = useMemo(() => {
    switch (labelSize) {
      case 'sm':
        return { label: 'font-size-xs font-light', value: 'font-size-md' }
      case 'md':
        return { label: 'font-size-md', value: 'font-size-lg' }
      case 'lg':
        return { label: 'font-size-md', value: 'font-size-2xl' }
      default:
        return { label: 'font-size-md', value: 'font-size-lg' }
    }
  }, [labelSize])

  return (
    <div
      className='flex flex-col gap-1 p-1 radius-lg'
      style={{
        ...(location === 'inside'
          ? { backgroundColor: simplifiedColor, color: textColor }
          : { width: '150px' }
        )
      }}
    >
      <span className={fontSizes.value}>{formatter(value, formatString)}</span>
      <span className={fontSizes.label}>{label}</span>
    </div>
  )
}

BlockItemLabel.propTypes = {
  labelSize: PropTypes.oneOf(['sm', 'md', 'lg']),
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  formatString: PropTypes.object.isRequired,
  location: PropTypes.oneOf(['inside', 'outside']),
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string
}
